import React, { useState } from 'react';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

// для запроса к внешнему ресурсу fsvok нам нужен ванильный axios
//import axios from 'axios';
import axios_api from '../Api';

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import default_photo from '../img/default_photo.png'

import Loader from './common/Loader';


export default function Product({goodsList, addProductClick, selectedYear}) {
  const media_url = useContext(MEDIA_URL);
  let photo_preview = undefined;
  let photo = undefined;
  let fsvokLink = undefined;
  let price = 0;

  let { productId } = useParams();
  productId = Number(productId);
  let product = false;
  for(let i in goodsList) {
    if (goodsList[i].id === productId) {
      product = goodsList[i];

      // убираем ".1" из номера каталога
      let catalog_number = product.nomenclature.catalog_entry.catalog_number
      if (catalog_number.endsWith(".1")) {
        product.nomenclature.catalog_entry.catalog_number = catalog_number.slice(0, -2);
      } 

      photo_preview = product.nomenclature.catalog_entry.photo_preview;
      photo = product.nomenclature.catalog_entry.photo; 
      fsvokLink = "https://www.fsvok.ru/programs/" + product.nomenclature.catalog_entry.catalog_number + "/";
      console.log(fsvokLink)

      
      // номенклатуры ВНУК
      if (product.nomenclature.type === "ВНУК") {
        price = product.price + product.nomenclature.base_price;
        console.log('ВНУК')
      } else {
        price = product.price
      }

      break;    
    }
  }

  function ShowImage(image) {
    window.open(image, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=600");
  }

  return product ? 
  (
    <>
      <div className="row">
        <h3 className="m-3"><Link className="lk-link" to={`/documents/catalog`}>Каталог {selectedYear}</Link></h3>
      </div>
      <div className="row mx-2 mt-4">  
        <div className="col-1 me-5">
          {photo ? 
            <img src={photo_preview ? media_url + photo_preview : default_photo} onClick= {() => ShowImage(media_url + photo)} style={{cursor: "pointer"}} alt="Product" className="" width="150" height="150"></img>
            : 
            <img src={photo_preview ? media_url + photo_preview : default_photo} alt="Product" className="" width="150" height="150"></img>
          }
        </div>
        <div className="col-9 ms-3">
          <p className='fs-3'>{product.nomenclature.name}</p>
          <p className=''>Цена <b> {price}</b> рублей</p> 
          <div className=''>
            {product.selected === true ? 
              <button className="lk-button lk-button-disabled">В корзине</button> : 
              <button className="lk-button" onClick={() => addProductClick(productId)}>Добавить в корзину</button>
            }
          </div>
        </div>
        <div className="col-2 justify-content-end">     </div>
      </div>
      <hr></hr>
      <ProductDescription catalogNumber={product.nomenclature.catalog_entry.catalog_number}/>      

      {/* 
      БОЛЕЕ НОВАЯ ВЕРСИЯ ProductDescription - реализует логику: запрос к сайту FSVOK только если нет описания товара в ЛК. Ждет, когда утвердядт такое решение
      <ProductDescription 
          catalogNumber={product.nomenclature.catalog_entry.catalog_number}
          fsvokLink={fsvokLink}
      />
      */}
    </>
  ) : (
    <>
    </>
  );
}

// БОЛЕЕ НОВАЯ ВЕРСИЯ ProductDescription - реализует логику: запрос к сайту FSVOK только если нет описания товара в ЛК. Ждет, когда утвердядт такое решение

/*
function ProductDescription({catalogNumber, fsvokLink}) {
  
  const [productDescription, setProductDescription] = useState()
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

    React.useEffect(() => {

    let description = axios_api.get(api_url + '/product_description/' + catalogNumber, {
      headers: {"Authorization": token}
    });
 
    description.then(
      (result) => {
        setProductDescription(result.data.description);
        console.log(result.data)
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);

  return (
    <div className="row mx-2">      
      {productDescription ? 
        <>
          <div className="col-1 me-5"></div>  
          <div className="col-9 ms-3 pt-4">
          <div dangerouslySetInnerHTML={{__html: productDescription }}></div>
          </div>
          <div className="col-2"></div>
        </>
        :  
        <ProductIframe fsvokLink={fsvokLink}/>
      }             

    </div>
  )
}
*/

function ProductDescription({catalogNumber}) {
  
  const [productDescription, setProductDescription] = useState()
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

    React.useEffect(() => {

    let description = axios_api.get(api_url + '/product_description/' + catalogNumber, {
      headers: {"Authorization": token}
    });
 
    description.then(
      (result) => {
        setProductDescription(result.data.description);
        console.log(result.data)
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);

  return (
    <div className="row mx-2">
      <div className="col-1 me-5"></div>  
      <div className="col-9 ms-3 pt-4">
        <div dangerouslySetInnerHTML={{__html: productDescription }}></div>
      </div>
      <div className="col-2"></div>
    </div>
  )
}

/*
Подгрузка с сайта fsvok отключена решением заказчика

function ProductIframe ({fsvokLink}) {
  const [siteHasData, setSiteHasData] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(true);

  React.useEffect(() => {
    let productData = axios.get(fsvokLink)

    productData.then(
      (result) => {
        setSiteHasData(true);
      },
      (error) => {
        console.log(error)
      }
    )  

  });


  function handleIfarmeLoad () {
    console.log("iframe loaded");
    setIframeLoading(false);
  }

  return siteHasData === true ?  
  ( 
    <>
      {iframeLoading == true && 
        <div className='ms-5'>
          <div className='ms-5 ps-5'>
            <Loader/>
          </div>
        </div>
      }
      <div id="outerdiv" className="ratio ratio-16x9 mx-4">
        <div  className="mx-2">
          <iframe id="fsvok" src={fsvokLink} onLoad={handleIfarmeLoad} title="FSVOK PRODUCT" allowfullscreen></iframe>
        </div>
      </div>
    </> 
  ) : (
    <div></div>
  );

}
*/

